import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { ApiService } from 'src/app/shared/service/api.service';
import { AuthService } from 'src/app/shared/service/auth.service';
import { TokenService } from 'src/app/shared/service/token.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-modulo',
  templateUrl: './modulo.component.html',
  styleUrls: ['./modulo.component.css']
})

export class ModuloComponent implements OnInit {
  visibleSale: boolean = false;
  visibleSalers: boolean = false;
  visibleFinancial: boolean = false;
  visibleManufacturing: boolean = false;
  moduleSale: any;
  moduleFinancial: any;
  moduleManufacturing: any;
  moduleSeller: any;
  ativeSale: boolean = false;
  ativeSeller: boolean = false;
  ativeFinancial: boolean = false;
  ativeManufacturing: boolean = false;
  isDisabled: boolean = true;
  baseApiUrl = environment.modaAPI;

  constructor(
    private router: Router,
    private authService: AuthService,
    private apiService: ApiService,
    private tokenService: TokenService,
    private httpClient: HttpClient,
  ) {}

  ngOnInit() {
    localStorage.removeItem('filterInfoBranchs');
    localStorage.removeItem('filterInfoMinDate');
    localStorage.removeItem('filterInfoMaxDate');
    localStorage.removeItem('filterInfoSellers');
    this.router.events.subscribe(event => {
      if(event instanceof NavigationEnd){
        let tenant = localStorage.getItem('tenant')?.toUpperCase()

        gtag('set', {'user_id': tenant});
      } 
    })    

    let objectComponentsAccess = localStorage.getItem('componentsAccess');
    let splitComponentsAccess : any = objectComponentsAccess?.split(',');
    this.moduleSale = splitComponentsAccess?.find((modulo:any) => modulo === "MOPFC001");
    this.moduleFinancial = splitComponentsAccess?.find((modulo:any) => modulo === "MOPFC002");
    this.moduleManufacturing = splitComponentsAccess?.find((modulo:any) => modulo === "MOPFC003");
    this.moduleSeller = splitComponentsAccess?.find((modulo:any) => modulo === "MOPFC004");
    if (splitComponentsAccess.length > 1) {
      this.moduleSale != undefined
      ? this.visibleSale = true
      : this.visibleSale = false
      this.moduleFinancial != undefined
      ? this.visibleFinancial = true
      : this.visibleFinancial = false
      this.moduleManufacturing != undefined
      ? this.visibleManufacturing = true
      : this.visibleManufacturing = false 
      this.moduleSeller != undefined
      ? this.isVisibleSalers()
      : this.visibleSalers = false
    } else {
      splitComponentsAccess.map((item:any) => {
        if (item === "MOPFC001") return this.goSale();
        if (item === "MOPFC002") return this.goFinancial();
        if (item === "MOPFC003") return this.goManufacturing();
        if (item === "MOPFC004") return this.goSalers();
      })
    }
  }

  goSale() {
    this.ativeSale = true;
    this.authService.getModulo(this.moduleSale);
    let element : any = document.getElementById("modulo");
    element.classList.add("off");
    setTimeout(() => {
      this.router.navigate(['/home/sale']);
    }, 2000);
  }

  isVisibleSalers() {
    this.getModuloSellers(this.moduleSeller);
    this.visibleSalers = true;
  }

  getModuloSellers(item: any) {
    let httpOptionsModulo = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + localStorage.getItem('tokenV2')
      })
    };
    this.httpClient.post(this.baseApiUrl + 'authorization/v2/mop-app-token', {component: item}, httpOptionsModulo).subscribe(
      (data: any) => {
        this.isSeller(data.access_token.toString());
      },
      (error: any) => {
        console.log('ERROR', error);
      }
    );
  }

  isSeller(item: any) {
    this.tokenService.saveToken(item);
    let httpOptionsModulo = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + item
      })
    };
    this.getIsSeller(httpOptionsModulo).subscribe((data) => {
      if (data.sellerCode) {
        localStorage.removeItem('authSeller');
        localStorage.setItem('authSeller', data.sellerCode);
        this.isDisabled = false;
      } else {
        this.isDisabled = true;
        let elementBtn : any = document.querySelectorAll(".btn-vendedores");
        elementBtn.forEach((el:any) => {
          el.classList.add('btn-vendedores-disabled');
        });
        localStorage.removeItem('authSeller');
      }
      
    })
  }

  getIsSeller(item: any) {
    return this.apiService.getIsSeller(item);
  }
  
  goSalers() {
    this.ativeSeller = true;
    let element : any = document.getElementById("modulo");
    element.classList.add("off");
    this.isVisibleSalers()
    setTimeout(() => {
      this.router.navigate(['/home/salers']);
    }, 2000);
  }

  goManufacturing() {
    this.ativeManufacturing = true;
    this.authService.getModulo(this.moduleManufacturing);
    let element : any = document.getElementById("modulo");
    element.classList.add("off");
    setTimeout(() => {
      this.router.navigate(['/home/manufacturing']);
    }, 2000);
  }

  goFinancial() {
    this.ativeFinancial = true;
    this.authService.getModulo(this.moduleFinancial);
    let element : any = document.getElementById("modulo");
    element.classList.add("off");
    setTimeout(() => {
      this.router.navigate(['/home/financial']);
    }, 2000);
  }

  openDoc() {
    const url = `https://tdn.totvs.com/pages/viewpage.action?pageId=880448700`;
    window.open(url, '_blank');
  }
}
